/// <reference path="DOMAttached.js" />

class GNOMActionTimer extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.el.attachedObj = this;
		this.popup = this.el.closest('.GNOMPage').querySelector('.outerPopup2');
		this.time = options.start;
		this.printTime();

		if (this.time > 0) {
			this.el.closest('.GNOMPage').classList.add('deactivated');
			this.setVisible();
		}

		this.timer = setInterval(this.onTimer.bind(this), 1000);
		this.el.closest('.tabbedApplication').attachedObj.registerInterval(this.timer);
	}

	onTimer() {
		if (this.time <= 0) {
			clearInterval(this.timer);
			this.setInVisible();
			this.el.closest('.GNOMPage').classList.remove('deactivated');
			return;
		}

		this.time--;
		this.printTime();
	}

	printTime() {
		this.el.innerHTML = Math.floor(this.time / 60) + ':' + ((this.time % 60 < 10) ? '0' : '') + (this.time % 60);
	}

	setVisible() {
		this.popup.style.display = 'inline';
	}

	setInVisible() {
		this.popup.style.display = 'none';
	}

	setTime(val) {
		clearInterval(this.timer);

		this.time = val;
		this.printTime();
		if (this.time > 0)
			this.setVisible();

		this.timer = setInterval(this.onTimer.bind(this), 1000);
		this.el.closest('.tabbedApplication').attachedObj.registerInterval(this.timer);
	}
}
